module.exports = __webpack_public_path__ + "static/media/la_kinfolk_dinner_1.84509f3d.jpg";